import { EntryCfop, ExitCfop } from '@/modules/Fiscal/enums/Cfop';

export default {
  methods: {
    putTypeOperationInCFOP(cfopInitials, cfops) {
      if (cfopInitials !== EntryCfop && cfopInitials !== ExitCfop) {
        throw this.$alert.error(
          'Grupo de iniciais de CFOP inválido!',
        );
      }
    
      const cfopsWithOperationCode = cfopInitials.map((initial) => cfops.map((cfop) => `${initial}${cfop}`)).flat();
      return cfopsWithOperationCode;
    },
  },
};
